import React from "react";
import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import { LabPrefix, URL } from "../../Constants/GlobalConstant";
import jsonData from "../../Interface/jsonData";
import Order from "../../Interface/Order";
import { getMessage } from "../../CommonFuntion/messages";
import {
  RedirectToSourceLoginIfSessionExpired,
  getUserSessionData,
  deleteUserSessionData,
  deleteUserLabelSessionData,
} from "../../CommonFuntion/CheckSession";
import { callOCCProfileAPI } from "../../CommonFuntion/callOCCAPI";
import { atLeastOneNull } from "../../CommonFuntion/SchemaValidation";
import LineItems from "./LineItem";
import AddressFormComponent from "./AddressFormComponent";
import AdditionalInformationComponent from "./AdditionalInformationComponent";
import OrderActions from "./OrderActions";
import {
  SaveLocalStorageInSession,
  getQuantity,
  checkQuantityFieldName,
  processPost,
  navigateToPath,
  navigateToConfirmOrder,
  findDistincPOAndLabel,
  findDistinctValues,
  saveCheckoutForm,
  RedirectBackToOCC,
  RedirectClick,
  fetchUserSessionData,
  getSchemaCatIdFromSchema,
  deriveCatKeysFromSchema,
} from "../../CommonFuntion/OrderingHelper";
import {
  GetRequesteDateAPI,
  GetSystemParameterValueByName,
  GetSystemParameterValueByNameTextFormat,
} from "../../CommonFuntion/SchemaAPICalls";
import {
  CreateVIPSOrderDetailsItem,
  CreateVIPSVarOrderHeaderItem,
  CreateVIPSVarOrderHeaderItemForCSVUpload,
  CreateVIPSOrderDetailsItemForCSVUpload,
} from "../../CommonFuntion/CreateOrder";
import CollectorComponent from "./CollectorComponent";
import DeliveryPriorityDropdown from "./DeliveryPriorityDropdown";
import SnackbarAlert from "./SnackbarAlert";
import { handleOrderSubmit } from "../../CommonFuntion/OrderingHelper";
import {
  GetRequesteDate,
  cancelOrder,
  getDivisionFromFactoryConfig,
  getFactoryConfigCustDiv,
} from "../../CommonFuntion/OrderingHelper";
import {
  setRequestNewAddressChild,
  setDelAddress1Child,
  setDelAddress2Child,
  setDelAddress3Child,
  setDelAddress4Child,
  setDelPostalCodeChild,
  SetDefaultDeliveryChild,
  setInvoiceAddressChild,
  setCustomerIdChild,
  setSelectedDeliveryChild,
  setSelectedCarriersChild,
  setSelectedFreightTermsChild,
  setCustPoNumberChild,
  setSamplingAndPackagingCodeChild,
  setLayoutApprovalChild,
  setOrderOnHoldChild,
  setCheckDuplicatePOChild,
  setCheckedChild,
  CollectorNameChild,
  setDelCustomerNameChild,
  setDelContactNameChild,
  setDelCountryCodeChild,
} from "../../CommonFuntion/OrderingChildSetters";
const CheckOut = (post) => {
  const childComponentRef = useRef(null);
  const additionalInformationComponentRef = useRef(null);
  const [layoutApproval, setLayoutApproval] = useState(false);
  const [orderOnHold, setOrderOnHold] = useState(false);

  let user2 = useSelector((state) => state.user);
  const schemaObject2 = useSelector((state) => state.SchemaObject);
  const [checked, setchecked] = useState(false);
  const [customerRequestDate, setCustomerRequestDate] = useState();
  const [customerOrderDate, setCustomerOrderDate] = useState(new Date());
  const [promiseDate, setPromiseDate] = useState("");
  const [requiredDate, SetRequiredDate] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [Post, setPostId] = useState("");
  const [minimumDate, setMinimumDate] = useState("");
  const [disableDateSelection, setDisableDateSelection] = useState(false);
  const [CheckCollector, setCheckCollector] = useState(false);
  const [CollectorName, setCollectorName] = useState("");
  const [DefaultDelivery, SetDefaultDelivery] = useState("0");
  const [SpecialInstruction, setSpecialInstruction] = useState("");
  const [shippingInstruction, setShippingInstruction] = useState("");
  const [shippingMark, setShippingMark] = useState("");
  const [samplingAndPackagingCode, setSamplingAndPackagingCode] = useState("");
  const [PrinterNotes, SetPrinterNotes] = useState("");
  const [orderLineInstructions, setOrderLineInstructions] = useState("");
  const [custPoNumber, setCustPoNumber] = useState("");
  const [VendorNotes, setVendorNotes] = useState("");
  const [retailerPurchaseOrderNo, setRetailerPurchaseOrderNo] = useState("");
  const [DelAddress1, setDelAddress1] = useState("");
  const [DelAddress4, setDelAddress4] = useState("");
  const [DelAddress2, setDelAddress2] = useState("");
  const [DelAddress3, setDelAddress3] = useState("");
  const [DelPostalCode, setDelPostalCode] = useState("");
  const [DelCustomerName, setDelCustomerName] = useState("");
  const [DelContactName, setDelContactName] = useState("");
  const [DelCountry, SetDeLCountry] = useState("");
  const [DeLAddressDrop, setDeLAddressDrop] = useState("");
  const [shipToID, setShipToID] = useState(0);
  const [selectedDelivery, setSelectedDelivery] = useState("");
  const [priorityId, setPriorityId] = useState(-1);
  const [lockDates, setLockDates] = useState(false);
  const [lastDaysRequired, setLastDaysRequired] = useState(null);
  const [priorityInitialized, setPriorityInitialized] = useState(false);
  const [requestNewAddress, setRequestNewAddress] = useState(false);

  var SessionArray = useSelector((state) => state.SessionArray);
  const LabelSession2 = useSelector((state) => state.LabelSession);
  let sumqty = 0;

  const [openDialog, setOpenDialog] = useState(false);
  const [newtempArr, setNewtempArr] = useState([]);
  const [selectedCarriers, setSelectedCarriers] = useState(0);
  const [selectedFreightTerms, setSelectedFreightTerms] = useState("");
  const searchParams = createSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(false);
  const [checkDuplicatePO, setCheckDuplicatePO] = useState(false);
  const [customerId, setCustomerId] = useState("");

  const {
    user_id,
    labelSessionArray,
    divisionId,
    DivDesc,
    schema_id,
    store_grp,
    customer_id,
    varlength,
    labelRef,
    usre_type,
    store_grp_desc,
    schema_name,
    occ_profile,
    prod_loc_occ,
    user_source,
  } = processPost(post);

  // Override divisionId/customerId from factory/division config when available
  const factoryConfigCustDiv = getFactoryConfigCustDiv(user_id, searchParams, labelSessionArray);
  const effectiveDivisionId = factoryConfigCustDiv?.divisionId
    || searchParams.get("SelectedDivision")
    || divisionId;
  const effectiveCustomerId = factoryConfigCustDiv?.customerId || "";

  const [csvUplaodEnabled, setCsvUplaodEnabled] = useState(false);
  const handleRedirectBackToOCC = () => {
    RedirectBackToOCC({
      user_id,
      searchParams,
      DefaultDelivery,
      selectedDelivery,
      DelAddress1,
      DelAddress4,
      DelAddress2,
      DelAddress3,
      DelPostalCode,
      DelCustomerName,
      DelContactName,
      DelCountry,
      custPoNumber,
      selectedCarriers,
      selectedFreightTerms,
      SpecialInstruction,
      PrinterNotes,
      VendorNotes,
      shippingInstruction,
      orderLineInstructions,
      retailerPurchaseOrderNo,
      shippingMark,
      samplingAndPackagingCode,
      customerId,
      DeLAddressDrop,
      shipToID,
      requestNewAddress,
      RedirectToSourceLoginIfSessionExpired,
      saveCheckoutForm,
      SaveLocalStorageInSession,
    });
  };

  const handleSetRequestNewAddress =
    setRequestNewAddressChild(setRequestNewAddress);
  const handleSetDelAddress1 = setDelAddress1Child(setDelAddress1);
  const handleSetDelAddress2 = setDelAddress2Child(setDelAddress2);
  const handleSetDelAddress3 = setDelAddress3Child(setDelAddress3);
  const handleSetDelAddress4 = setDelAddress4Child(setDelAddress4);
  const handleSetDelPostalCode = setDelPostalCodeChild(setDelPostalCode);

  const handleSetDefaultDelivery = SetDefaultDeliveryChild(SetDefaultDelivery);
  const handleSetInvoiceAddress = setInvoiceAddressChild(setPostId);
  const handleSetCustomerId = setCustomerIdChild(setCustomerId);
  const handleSetSelectedDelivery =
    setSelectedDeliveryChild(setSelectedDelivery);
  const handleSetSelectedCarriers =
    setSelectedCarriersChild(setSelectedCarriers);
  const handleSetSelectedFreightTerms = setSelectedFreightTermsChild(
    setSelectedFreightTerms
  );
  const handleSetCustPoNumber = setCustPoNumberChild(setCustPoNumber);
  const handleSetSamplingAndPackagingCode = setSamplingAndPackagingCodeChild(
    setSamplingAndPackagingCode
  );
  const handleSetLayoutApproval = setLayoutApprovalChild(setLayoutApproval);
  const handleSetOrderOnHold = setOrderOnHoldChild(setOrderOnHold);
  const handleSetCheckDuplicatePO =
    setCheckDuplicatePOChild(setCheckDuplicatePO);

  const handleSetChecked = setCheckedChild(setchecked, setCheckCollector);
  const handleCollectorName = CollectorNameChild(setCollectorName);
  const handleSetDelCustomerName = setDelCustomerNameChild(setDelCustomerName);
  const handleSetDelContactName = setDelContactNameChild(setDelContactName);
  const handleSetDelCountryCode = setDelCountryCodeChild(SetDeLCountry);

  const [schemaObject, setSchemaObject] = useState([]);
  const [user, setUser] = useState([]);
  const [LabelSession, setLabelSession] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  var LabelsWithVariableData = [];
  const [labelsWithVariableData, setLabelsWithVariableData] = useState([]);
  useEffect(() => {
    // Delay initial data fetch until priority dropdown initializes
    if (!priorityInitialized) return;
    fetchUserSessionData({
      user_id,
      searchParams,
      labelSessionArray,
      LabelSession2,
      setLabelSession,
      setSchemaObject,
      setUser,
      setNewtempArr,
      setLabelsWithVariableData,
      setIsLoading,
      setDisableDateSelection,
      setMinimumDate,
      SetRequiredDate,
      setCustomerRequestDate,
      setPromiseDate,
      setCustomerOrderDate,
      getUserSessionData,
      atLeastOneNull,
      schemaObject2,
      user2,
      csvUplaodEnabled,
      findDistinctValues,
      findDistincPOAndLabel,
      getQuantity,
      checkQuantityFieldName,
      LabPrefix,
      getMessage,
      GetRequesteDate,
      GetRequesteDateAPI,
      schema_name,
      divisionId: effectiveDivisionId,
      store_grp,
      setOpenDialog,
      GetSystemParameterValueByName,
      setCsvUplaodEnabled,
      lockDates,
      priorityId,
      setSnackbarMessage,
      setOpenSnackbar,
    });
  }, [priorityInitialized, csvUplaodEnabled, priorityId, lockDates]);

  // EPK: set default special instruction from system parameter
  useEffect(() => {
    if (store_grp !== "EPK") return;
    let isMounted = true;
    GetSystemParameterValueByNameTextFormat("REACT_EPK_DEFAULT_SPEC_INSTR")
      .then((data) => {
        if (isMounted && data && typeof data === "string" && data.trim()) {
          setSpecialInstruction(data.trim());
        }
      })
      .catch(() => {});
    return () => { isMounted = false; };
  }, [store_grp]);

  const [collectorNamevalidation, setcollectorNamevalidation] = useState({
    msg: "",
    invalid: false,
  });

  const [showPOAlert, setShowPOAlert] = useState({
    alertDescription: "",
    open: false,
    agreed: false,
  });

  var orderInprogess = true;
  useEffect(() => {
    RedirectToSourceLoginIfSessionExpired(
      user_id,
      searchParams.get("session_id"),
      searchParams.get("OCC"),
      orderInprogess
    );
  }, [showPOAlert, DeLAddressDrop]);
  // Required date now comes from GetRequesteDateAPI using selected priority.

  // When dates are locked by priority, clear API-driven customer/promise dates
  // and remove any minimumDate restriction set earlier by GetRequesteDate.
  useEffect(() => {
    if (lockDates) {
      setCustomerRequestDate(null);
      setPromiseDate(null);
      setMinimumDate("");
    }
  }, [lockDates]);

  if (typeof SessionArray !== "undefined") {
    SessionArray = JSON.parse(localStorage.getItem("sessionArray"));
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    // Derive catalogue catID from schema (CTB prefix) if available
    const derivedCatId = getSchemaCatIdFromSchema(schemaObject);
    if (derivedCatId !== null) {
      try { Order.catID = derivedCatId; } catch (_) {}
    }
    // Derive CAT keys (key1, key2, key3) from schema (prefix CAT with keyIndex 1/2/3)
    const { k1, k2, k3 } = deriveCatKeysFromSchema(schemaObject, user);
    try {
      if (k1 !== "") Order.key1 = k1;
      if (k2 !== "") Order.key2 = k2;
      if (k3 !== "") Order.key3 = k3;
    } catch (_) {}
    // Apply selected delivery priority to Order and request date
    try {
      Order.priority_id = priorityId || "";
      Order.requestDate = requiredDate || Order.requestDate;
    } catch (_) {}
    handleOrderSubmit({
      e,
      CheckCollector,
      CollectorName,
      setcollectorNamevalidation,
      childComponentRef,
      additionalInformationComponentRef,
      csvUplaodEnabled,
      jsonData,
      newtempArr,
      Order,
      user_source,
      divisionId: effectiveDivisionId,
      user_id,
      store_grp,
      PrinterNotes,
      orderLineInstructions,
      VendorNotes,
      retailerPurchaseOrderNo,
      SpecialInstruction,
      shippingInstruction,
      schema_id,
      requiredDate,
      customerId,
      customerRequestDate,
      promiseDate,
      customerOrderDate,
      selectedFreightTerms,
      selectedCarriers,
      samplingAndPackagingCode,
      shippingMark,
      orderOnHold,
      layoutApproval,
      CreateVIPSOrderDetailsItemForCSVUpload,
      CreateVIPSVarOrderHeaderItemForCSVUpload,
      CreateVIPSOrderDetailsItem,
      CreateVIPSVarOrderHeaderItem,
      LabelSession,
      LabPrefix,
      schemaObject,
      user,
      custPoNumber,
      setIsLoading,
      RedirectToSourceLoginIfSessionExpired,
      searchParams,
      getMessage,
      URL,
      navigateToConfirmOrder,
      prod_loc_occ,
      occ_profile,
      schema_name,
      store_grp_desc,
      navigate,
      deleteUserSessionData,
      deleteUserLabelSessionData,
      priorityRequired: lockDates,
      setSnackbarMessage,
      setOpenSnackbar,
    });
  };

  if (Post) {
    jsonData.InvoiceAddress.customer_address1 = Post?.customer_address1;
    jsonData.InvoiceAddress.customer_id = Post?.customer_id;
    jsonData.InvoiceAddress.customer_name = Post?.customer_name;
    jsonData.InvoiceAddress.customer_address1 = Post?.customer_address1;
    jsonData.InvoiceAddress.customer_address2 = Post?.customer_address2;
    jsonData.InvoiceAddress.customer_address3 = Post?.customer_address3;
    jsonData.InvoiceAddress.customer_address4 = Post?.customer_address4;
    jsonData.InvoiceAddress.customer_city = Post?.customer_city;
    jsonData.InvoiceAddress.customer_country = Post?.customer_country;
    jsonData.InvoiceAddress.customer_country_code = Post?.customer_country_cod;
    jsonData.InvoiceAddress.customer_post_code = Post?.customer_post_code;
  }

  if (selectedDelivery) {
    jsonData.DeliveryAddress.contact_name = selectedDelivery?.contact_name;
    jsonData.DeliveryAddress.delivery_customer_name =
      selectedDelivery.delivery_customer_name;
    jsonData.DeliveryAddress.delivery_email = "";
    jsonData.DeliveryAddress.delivery_address1 =
      selectedDelivery.delivery_address1;
    jsonData.DeliveryAddress.delivery_address2 =
      selectedDelivery.delivery_address2;
    jsonData.DeliveryAddress.delivery_address3 =
      selectedDelivery.delivery_address3;
    jsonData.DeliveryAddress.delivery_address4 =
      selectedDelivery.delivery_address4;
    jsonData.DeliveryAddress.delivery_city = "";
    jsonData.DeliveryAddress.delivery_country = "";
    jsonData.DeliveryAddress.delivery_country_code =
      selectedDelivery.delivery_country_code;
    jsonData.DeliveryAddress.delivery_post_code =
      selectedDelivery.delivery_post_code;
    jsonData.DeliveryAddress.shipToID = selectedDelivery.shipToID;
  } else {
    jsonData.DeliveryAddress.contact_name = DelContactName;
    jsonData.DeliveryAddress.delivery_customer_name = DelCustomerName;
    jsonData.DeliveryAddress.delivery_email = "";
    jsonData.DeliveryAddress.delivery_address1 = DelAddress1;
    jsonData.DeliveryAddress.delivery_address2 = DelAddress2;
    jsonData.DeliveryAddress.delivery_address3 = DelAddress3;
    jsonData.DeliveryAddress.delivery_address4 = DelAddress4;
    jsonData.DeliveryAddress.delivery_city = "";
    jsonData.DeliveryAddress.delivery_country = "";
    jsonData.DeliveryAddress.delivery_country_code = DelCountry;
    jsonData.DeliveryAddress.delivery_post_code = DelPostalCode;
  }
  const handleRedirectClick = () => {
    RedirectClick({
      user_id,
      searchParams,
      DefaultDelivery,
      selectedDelivery,
      DelAddress1,
      DelAddress4,
      DelAddress2,
      DelAddress3,
      DelPostalCode,
      DelCustomerName,
      DelContactName,
      DelCountry,
      custPoNumber,
      selectedCarriers,
      selectedFreightTerms,
      SpecialInstruction,
      PrinterNotes,
      VendorNotes,
      shippingInstruction,
      orderLineInstructions,
      retailerPurchaseOrderNo,
      shippingMark,
      samplingAndPackagingCode,
      customerId,
      DeLAddressDrop,
      shipToID,
      requestNewAddress,
      saveCheckoutForm,
      SaveLocalStorageInSession,
      navigateToPath,
      SessionArray,
      labelSessionArray,
      navigate,
      labelsWithVariableData,
      store_grp_desc,
    });
  };
  let contentStyle = {
    padding: "0 30px",
  };

  let isInteralOrAdminUser = true;
  if (usre_type !== "A" && usre_type !== "I") {
    isInteralOrAdminUser = false;
  }

  // read childPages persisted by OEForm
  let childPages = false;
  try {
    const rawChild = localStorage.getItem("childPages");
    childPages = rawChild ? JSON.parse(rawChild) === true : false;
  } catch {
    childPages = false;
  }

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>{getMessage("checkoutProcessing")}</p>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div style={contentStyle}>
          <Grid container spacing={2}>
            <LineItems
              lineNo={newtempArr}
              formData={user}
              openDialog={openDialog}
              post={post}
              searchParams={searchParams}
              csvUplaodEnabled={csvUplaodEnabled}
            ></LineItems>
              <DeliveryPriorityDropdown
                divisionId={effectiveDivisionId}
                storeGroup={store_grp}
                onRequiredChange={({ required, defaultDays, defaultPriorityId }) => {
                  setLockDates(!!required);
                  if (required) {
                    setPriorityId(defaultPriorityId ?? -1);
                    setLastDaysRequired(typeof defaultDays === "number" ? defaultDays : null);
                  }
                  setPriorityInitialized(true);
                }}
                onChange={({ priorityId, daysRequired, required }) => {
                  setLockDates(!!required);
                  setPriorityId(priorityId);
                  setLastDaysRequired(Number(daysRequired) || 0);
                  setPriorityInitialized(true);
                }}
              />
              { /* Ensure Required Date binds when required becomes true even if dropdown default event races */ }
              {
                /* compute required date from lastDaysRequired when lockDates switches to true */
              }
            <CollectorComponent
              childComponentRef={childComponentRef}
              setCheckedChild={handleSetChecked}
              CollectorNameChild={handleCollectorName}
            />
          </Grid>

          <AddressFormComponent
            divisionId={effectiveDivisionId}
            factoryConfigCustomerId={effectiveCustomerId}
            user_id={user_id}
            isInteralOrAdminUser={isInteralOrAdminUser}
            schema_id={schema_id}
            SetDefaultDeliveryChild={handleSetDefaultDelivery}
            setInvoiceAddressChild={handleSetInvoiceAddress}
            ref={childComponentRef}
            setCustomerIdChild={handleSetCustomerId}
            setSelectedDeliveryChild={handleSetSelectedDelivery}
            isCollectOrder={checked}
            searchParams={searchParams}
            setRequestNewAddressChild={handleSetRequestNewAddress}
            setDelAddress1Child={handleSetDelAddress1}
            setDelAddress2Child={handleSetDelAddress2}
            setDelAddress3Child={handleSetDelAddress3}
            setDelAddress4Child={handleSetDelAddress4}
            setDelPostalCodeChild={handleSetDelPostalCode}
            setDelCustomerNameChild={handleSetDelCustomerName}
            setDelContactNameChild={handleSetDelContactName}
            setDelCountryCodeChild={handleSetDelCountryCode}
          />
          <AdditionalInformationComponent
            user_id={user_id}
            schema_id={schema_id}
            store_grp={store_grp}
            ref={additionalInformationComponentRef}
            isInteralOrAdminUser={isInteralOrAdminUser}
            csvUplaodEnabled={csvUplaodEnabled}
            divisionId={effectiveDivisionId}
            minimumDate={minimumDate}
            lockDates={lockDates}
            setSelectedCarriersChild={handleSetSelectedCarriers}
            setSelectedFreightTermsChild={handleSetSelectedFreightTerms}
            setCustPoNumberChild={handleSetCustPoNumber}
            customerRequestDate={customerRequestDate}
            setCustomerRequestDate={setCustomerRequestDate}
            requiredDate={requiredDate}
            SetRequiredDate={SetRequiredDate}
            promiseDate={promiseDate}
            setPromiseDate={setPromiseDate}
            SpecialInstruction={SpecialInstruction}
            setSpecialInstruction={setSpecialInstruction}
            PrinterNotes={PrinterNotes}
            SetPrinterNotes={SetPrinterNotes}
            VendorNotes={VendorNotes}
            setVendorNotes={setVendorNotes}
            shippingInstruction={shippingInstruction}
            setShippingInstruction={setShippingInstruction}
            orderLineInstructions={orderLineInstructions}
            setOrderLineInstructions={setOrderLineInstructions}
            retailerPurchaseOrderNo={retailerPurchaseOrderNo}
            setRetailerPurchaseOrderNo={setRetailerPurchaseOrderNo}
            shippingMark={shippingMark}
            setShippingMark={setShippingMark}
            samplingAndPackagingCode={samplingAndPackagingCode}
            setSamplingAndPackagingCodeChild={handleSetSamplingAndPackagingCode}
            tempArr={newtempArr}
            setLayoutApprovalChild={handleSetLayoutApproval}
            setOrderOnHoldChild={handleSetOrderOnHold}
            disableDateSelection={disableDateSelection}
            setCheckDuplicatePOChild={handleSetCheckDuplicatePO}
            searchParams={searchParams}
          />
          <OrderActions
            prod_loc_occ={prod_loc_occ}
            occ_profile={occ_profile}
            schema_name={schema_name}
            user_id={user_id}
            schema_id={schema_id}
            searchParams={searchParams}
            getMessage={getMessage}
            RedirectBackToOCC={handleRedirectBackToOCC}
            cancelOrder={() =>
              cancelOrder(
                user_id,
                searchParams,
                deleteUserSessionData,
                deleteUserLabelSessionData,
                callOCCProfileAPI,
                prod_loc_occ,
                occ_profile,
                schema_name
              )
            }
            RedirectClick={handleRedirectClick}
            isLoading={isLoading}
            checkDuplicatePO={checkDuplicatePO}
            csvUplaodEnabled={csvUplaodEnabled}
            childPages={childPages} // pass persisted value to actions
          />

          <div style={{ marginBottom: 100 }}></div>
        </div>
      </form>
      <SnackbarAlert
        open={openSnackbar}
        message={snackbarMessage}
        severity="error"
        onClose={() => setOpenSnackbar(false)}
      />
    </div>
  );
};

export default CheckOut;
